import { Tag } from "antd";
import React from "react";
import { AiOutlineBank, AiOutlineContacts, AiOutlineTeam } from "react-icons/ai";
import GroupListScreen from "../GroupListScreen";
import PersonCell from "../PersonCell";
import useGroupBranchOptions from "../useGroupBranchOptions";
import { fetchGroupParents } from "../../../services/groupConsole.service";

// User has no first_name/last_name of its own — for a parent that data lives
// only on the linked Parent document, at r.parent.
const nameColumn = {
  title: "Name",
  key: "name",
  render: (r) => (
    <PersonCell
      id={r.parent?._id}
      image={r.parent?.profile_image}
      firstName={r.parent?.first_name}
      lastName={r.parent?.last_name}
      subtitle={r.parent?.occupation}
    />
  ),
};

const buildStats = (rows) => {
  const total = rows.length;
  const branches = new Set(rows.map((r) => r.school)).size;
  const withContact = rows.filter((r) => r.email || r.phone).length;
  return [
    {
      key: "total",
      label: "Parents",
      value: total,
      icon: <AiOutlineTeam size={15} />,
      color: "indigo",
    },
    {
      key: "branches",
      label: "Branches",
      value: branches,
      icon: <AiOutlineBank size={15} />,
      color: "sky",
    },
    {
      key: "contact",
      label: "With email/phone",
      value: withContact,
      icon: <AiOutlineContacts size={15} />,
      color: "emerald",
    },
  ];
};

const GroupParents = () => {
  const branches = useGroupBranchOptions();
  return (
    <GroupListScreen
      title="Parents"
      queryKey="group-console-parents"
      fetchFn={fetchGroupParents}
      searchPlaceholder="Search by name, email or phone"
      branchOptions={branches.options}
      branchOptionsLoading={branches.isLoading}
      statCards={buildStats}
      pageSize={10}
      columns={[
        nameColumn,
        {
          title: "Relation",
          key: "relation",
          align: "center",
          render: (r) =>
            r.parent?.relation ? <Tag>{r.parent.relation}</Tag> : "—",
        },
        { title: "Email", dataIndex: "email", align: "center" },
        { title: "Phone", dataIndex: "phone", align: "center" },
      ]}
    />
  );
};

export default GroupParents;
